import { useState } from "react";
import { useSelector } from "@xstate/react";

import { globalActor } from "../state/GlobalContextProvider";

import Header from "./screens/0_header";
import Menu from "./screens/0_menu";
import Sidebar from "./screens/0_sidebar";

import StartScreen from "./screens/1_start";
import Disclaimer from "./screens/2_disclaimer";
import PlaceScreen from "./screens/3_place";
import ReadyScreen from "./screens/4_readyForStart";
import Continue from "./screens/5_continue";
import WhatPatients from "./screens/6_whatPatients";
import data from "../animData";

const continueStates = Object.keys(data);
continueStates.push("primeBottleWait");

export default function Dom() {
  const state = useSelector(globalActor, (snapshot) => snapshot.value);
  const showMenu = useSelector(
    globalActor,
    (snapshot) => snapshot.context.showMenu
  );

  const showContinue = continueStates.some((el) => state.match(el));

  const setX = (e) => (window.r.current.position.x = e.target.value);
  const setY = (e) => (window.r.current.position.y = e.target.value);
  const setZ = (e) => (window.r.current.position.z = e.target.value);

  return (
    <>
      {state !== "start" && state !== "loading" ? <Header /> : ""}

      {state === "place" ? <PlaceScreen /> : null}
      {state === "readyForStart" ? <ReadyScreen /> : null}
      {showContinue ? <Continue /> : ""}
      <Sidebar />
      {state === "whatPatients" ? <WhatPatients /> : ""}
      {state === "disclaimer" ? <Disclaimer /> : null}
      {state === "loading" || state === "start" ? <StartScreen /> : null}

      {showMenu && <Menu />}

      {/* <div id="place">
        <input type="range" min={-100} max={100} onChange={setX}></input>
        <input type="range" min={-100} max={100} onChange={setY}></input>
        <input type="range" min={-100} max={100} onChange={setZ}></input>
      </div> */}
    </>
  );
}

// let [placementMode, setPlacementMode] = useState(true);
//   const [started, setStarted] = useState(false);
//   const [scale, setScale] = useState(50);

// {placementMode ? (
//   <div
//     id="zappar-placement-ui"
//     onClick={() => {
//       setPlacementMode((currentPlacementMode) => !currentPlacementMode);
//     }}
//     onKeyDown={() => {
//       setPlacementMode((currentPlacementMode) => !currentPlacementMode);
//     }}
//     role="button"
//     tabIndex={0}
//   >
//     Tap here to
//     {placementMode ? " place " : " pick up "}
//     the object
//   </div>
// ) : (
//   ""
// )}
// {!placementMode && (
//   <label>
//     <span>Model Scale</span>
//     <input
//       type="range"
//       min={30}
//       max={100}
//       value={scale}
//       onChange={(e) => setScale(e.target.value)}
//     ></input>
//   </label>
// )}

// {!started && (
//   <div className="StartScreen" onClick={(_) => setStarted(true)}>
//     <h1> Miebo WebAR </h1>
//     <button>Start Experience</button>
//   </div>
// )}
